import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import SimpleModal from '@bufferapp/ui/SimpleModal';

import { useTranslation } from 'react-i18next';

import {
  ModalWrapperStyled,
  ModalActionsStyled,
  TitleStyled,
  ParagraphStyled,
  ButtonStyled,
} from './styles';

export const DeleteConfirmationModal: React.FC<{
  onConfirm: () => void;
  onCancel: () => void;
}> = ({ onConfirm, onCancel }) => {
  const { t } = useTranslation();

  const onKeyDown = (event: KeyboardEvent): void => {
    if (event.key === 'Enter') {
      event.preventDefault();
      onConfirm();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', onKeyDown);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  return (
    <SimpleModal closeAction={onCancel}>
      <ModalWrapperStyled>
        <TitleStyled type="h3">
          {t('content.modals.deleteConfirmation.title')}
        </TitleStyled>
        <ParagraphStyled type="p">
          {t('content.modals.deleteConfirmation.description')}
        </ParagraphStyled>
        <ModalActionsStyled>
          <ButtonStyled
            type="text"
            onClick={onCancel}
            label={t('content.modals.deleteConfirmation.cancel')}
          />
          <ButtonStyled
            type="danger"
            onClick={onConfirm}
            label={t('content.modals.deleteConfirmation.confirm')}
          />
        </ModalActionsStyled>
      </ModalWrapperStyled>
    </SimpleModal>
  );
};

DeleteConfirmationModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
